import React from 'react';
import {WeaSearchGroup, WeaFormItem, WeaLocaleProvider, WeaCheckbox } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import SynergySetting4Designer from './synergy/SynergySetting4Designer';

// 日历日程
export default class Content_MyCalendar extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            value: this.props.isShowLunarDatas || '0'
        }
    }
    render() {
        const {hpid, eid, ebaseid, eShareLevel, synergyParams} = this.props;
        const {stype, pagetype, ispagedeal} = synergyParams;

        let customComponent = <div></div>;
        if (eShareLevel == '2') {
            customComponent = (
                <div>
                    {hpid < 0 && stype == 'wf' && pagetype == 'operat' && ispagedeal == '1' ? <span className="synergy-setting-btn" onClick={() => this.ss4d.onShow({...synergyParams, hpid, ebaseid, eid, isGlobal: true})}>{getLabel(17632	,'参数设置')}</span> : ''}
                </div>
            );
        }

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true} customComponent={customComponent}>
                    <SynergySetting4Designer ref={(ss4d) => this.ss4d = ss4d}/>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {this.props.eShareLevel == '2' ? <WeaFormItem label={'是否显示农历'} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaCheckbox display="switch" value={this.state.value} onChange={value => this.setState({value: value})}/>
                    </WeaFormItem> : ''}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            isShowLunarDatas: this.state.value
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_MyCalendar.js